<template>
  <div class="outer-wrapper">
    <div class="title">
      <p>库存管理</p>
    </div>
    <Tabs v-model="tabSw" @on-click="tabClick">
      <TabPane label="全部物品" icon="logo-buffer" name="goods">
        <goods-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="100%"
        ></goods-list>
      </TabPane>
      <Button
        v-show="tabSw==='goods'"
        @click="openModal('newCreate')"
        slot="extra"
        type="primary"
        style="margin-right:5px;"
      >新增品类</Button>
      <Button
        v-show="tabSw==='goods'"
        @click="openModal('purchaseCart')"
        slot="extra"
        type="primary"
        style="margin-right:5px;"
      ><Icon type="ios-cart-outline" /> 待购清单</Button>
      <TabPane label="进出库记录" icon="logo-dropbox" name="flow">
        <goods-flow-list
          :columnsFormatData="columnsFormatFlow"
          askData="goodsFlow"
          :refreshData="update_count"
          main_width="100%"
        ></goods-flow-list>
      </TabPane>
      <TabPane label="快捷操作" icon="ios-game-controller-b-outline" name="operation">
        <simple-list
          :columnsFormatData="columnsFormatOperation"
          askData="flowOperation"
          :refreshData="update_count2"
          main_width="100%"
        ></simple-list>
      </TabPane>
      <TabPane label="领料记录单" icon="ios-clipboard" name="record">
        <div class="record-wrapper">
          <p><label for="">选择记录日期：
            <input type="date" v-model="currentRecordDate" class="date-input" />
            <span style="margin:0 20px;">至</span>
            <input type="date" v-model="currentRecordDateEnd" class="date-input"/>
            <Button @click="getFlowRecord" style="height:38px;margin-left:20px;"><Icon type="ios-search-outline" :size="24"/></Button>
            </label>
            <span class="print-bt"><Button class="print-button" v-print="'#to_print_task_tag'">打领料记录单</Button></span>
            </p>
          <Spin fix v-show="spin">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
        </Spin>
        <div id="to_print_task_tag" v-print="'#to_print_task_tag'">
          <div
            class="tag-wrapper"
            v-for="(item,index) in flowListOfDay"
            :key="index"
            style="page-break-after: always;"
          >
            <ware-note :item="item"></ware-note>
          </div>
        </div>
        </div>
      </TabPane>
      <Button
        v-show="tabSw==='operation'"
        @click="openModal('newOperation')"
        slot="extra"
        type="primary"
        style="margin-right:5px;"
      >新增操作</Button>
      <TabPane label="全部申购单" icon="logo-buffer" name="purchase">
        <purchase-list
          :columnsFormatData="columnsFormatPurchase"
          askData="purchasePackageList"
          :refreshData="update_count"
          main_width="100%"
        ></purchase-list>
      </TabPane>
    </Tabs>
    <Modal v-model="modalValue.newCreate" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('newCreate')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新增品类</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>物品名称：</td>
              <td>
                <input type="text" placeholder="例：螺栓" v-model="newItem.name" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>类别：</td>
              <td>
                <select v-model="newItem.catagory" style="width:200px;">
                  <option
                    :value="ele.value"
                    v-for="ele in catagoryList"
                    :key="ele.value+'mat'"
                  >{{ele.text}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>子类别：</td>
              <td>
                <input type="text" placeholder="自定义类别" v-model="newItem.sub_catagory" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>属性：</td>
              <td>
                <span
                  style="width:200px;cursor:pointer;"
                  @click="openModal('propertyBox')"
                >{{propertyForFormView?propertyForFormView:'点击添加属性'}}</span>
              </td>
            </tr>
            <tr>
              <td>警戒库存：</td>
              <td>
                <input type="number" placeholder v-model="newItem.alert_amount" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>单位：</td>
              <td>
                <input type="text" placeholder="默认为“个”" v-model="newItem.pit" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>库位：</td>
              <td>
                <input type="text" placeholder v-model="newItem.position_A" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>货位：</td>
              <td>
                <input type="text" placeholder v-model="newItem.position_B" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="newItem.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')" :disabled="goodsCreateValid">提交</Button>
        <Button size="large" @click="closeModal('newCreate')">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modalValue.propertyBox" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('propertyBox')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>物品属性</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>规格：</td>
              <td>
                <input type="text" placeholder v-model="property.spec" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>型号：</td>
              <td>
                <input type="text" placeholder v-model="property.model" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>材质：</td>
              <td>
                <input type="text" placeholder v-model="property.mat" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>容积(L)：</td>
              <td>
                <input type="number" placeholder v-model="property.volume" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>供应商：</td>
              <td>
                <input type="text" placeholder v-model="property.seller" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>品牌：</td>
              <td>
                <input type="text" placeholder v-model="property.brand" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>外径(mm)：</td>
              <td>
                <input type="number" placeholder v-model="property.diameter" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>内径(mm)：</td>
              <td>
                <input type="number" placeholder v-model="property.bore" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>壁厚(mm)：</td>
              <td>
                <input type="number" placeholder v-model="property.thickness" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>压力(MPa)：</td>
              <td>
                <input type="number" placeholder v-model="property.pressure" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>标准：</td>
              <td>
                <input type="text" placeholder v-model="property.standard" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>等级：</td>
              <td>
                <input type="text" placeholder v-model="property.grade" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>其他：</td>
              <td>
                <input type="text" placeholder v-model="property.other" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="saveProperty('propertyBox')">确定</Button>
        <Button size="large" @click="closeModal('propertyBox')">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modalValue.goodsAlter" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('goodsAlter')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>更新内容</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>物品名称：</td>
              <td>
                <input type="text" placeholder="例：螺栓" v-model="goods.name" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>类别：</td>
              <td>
                <select v-model="goods.catagory" style="width:200px;">
                  <option
                    :value="ele.value"
                    v-for="ele in catagoryList"
                    :key="ele.value+'mat'"
                  >{{ele.text}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>子类别：</td>
              <td>
                <input type="text" placeholder="可自定义子类别" v-model="goods.sub_catagory" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>属性：</td>
              <td>
                <span
                  style="width:200px;cursor:pointer;"
                  @click="openModal('propertyBox')"
                >{{propertyForFormView?propertyForFormView:'点击添加属性'}}</span>
              </td>
            </tr>
            <tr>
              <td>警戒库存：</td>
              <td>
                <input type="number" placeholder v-model="goods.alert_amount" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>单位：</td>
              <td>
                <input type="text" placeholder="默认为“个”" v-model="goods.pit" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>库位：</td>
              <td>
                <input type="text" placeholder v-model="goods.position_A" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>货位：</td>
              <td>
                <input type="text" placeholder v-model="goods.position_B" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="goods.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="goodsAlterSubmit('goodsAlter')">提交</Button>
        <Button size="large" @click="closeModal('goodsAlter')">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modalValue.goodsIn" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('goodsIn')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>入库</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>物品名称：</td>
              <td>{{goodsIn.name}}</td>
            </tr>
            <tr>
              <td>类别：</td>
              <td>{{revealCatagory(goodsIn.catagory)}}</td>
            </tr>
            <tr>
              <td>属性：</td>
              <td>{{revealProperty(goodsIn.property)}}</td>
            </tr>
            <tr>
              <td>入库数量：</td>
              <td>
                <input type="number" placeholder v-model="goodsIn.amount" style="width:200px;" />
                {{goodsIn.pit}}
              </td>
            </tr>
            <tr>
              <td>入库原因：</td>
              <td>
                <select v-model="goodsIn.reason" style="width:200px;">
                  <option
                    :value="ele.value"
                    v-for="ele in inReasonList"
                    :key="ele.value+'reason'"
                  >{{ele.text}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>物品来源：</td>
              <td>
                <input
                  type="text"
                  placeholder="购买的填经销商/退回的填相应职员姓名"
                  v-model="goodsIn.place"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="goodsIn.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="goodsFlowSubmit('goodsIn')">提交</Button>
        <Button size="large" @click="closeModal('goodsIn')">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modalValue.goodsOut" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('goodsOut')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>出库</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>物品名称：</td>
              <td>{{goodsOut.name}}</td>
            </tr>
            <tr>
              <td>类别：</td>
              <td>{{revealCatagory(goodsIn.catagory)}}</td>
            </tr>
            <tr>
              <td>属性：</td>
              <td>{{revealProperty(goodsIn.property)}}</td>
            </tr>
            <tr>
              <td>出库数量：</td>
              <td>
                <input type="number" placeholder v-model="goodsOut.amount" style="width:200px;" />
                {{goodsOut.pit}}
              </td>
            </tr>
            <tr>
              <td>出库原因：</td>
              <td>
                <select v-model="goodsOut.reason" style="width:200px;">
                  <option
                    :value="ele.value"
                    v-for="ele in outReasonList"
                    :key="ele.value+'reason'"
                  >{{ele.text}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>物品去向：</td>
              <td>
                <input
                  type="text"
                  placeholder="领用的填相应职员姓名"
                  v-model="goodsOut.place"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="goodsOut.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="goodsFlowSubmit('goodsOut')">提交</Button>
        <Button size="large" @click="closeModal('goodsOut')">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modalValue.newOperation" fullscreen :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('newOperation')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新增操作组合</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <p><span>操作名称：</span><input type="text" v-model="operation.name"></p>
          <p><span>操作介绍：</span><input type="text" v-model="operation.description"></p>
          <p>全部操作内容：</p>
          <Table width="100%"  border :columns="addOperationFormat" :data="operationList" style="margin:0 auto;">
        </Table>
        <p style="text-align:center;margin:10px auto;"><Button type="warning" size="large" @click="openModal('addOneOperation')">添加物品操作</Button></p>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newOperationSubmit('newOperation')" :disabled="operationValid">提交</Button>
        <Button size="large" @click="closeModal('newOperation')">取消</Button>
      </div>
    </Modal>
    <single-selector
      :askData="askData"
      :modalSwitch="modalValue.addOneOperation"
      :columnsFormatData="columnsFormatSelect"
      @closeModal="closeModal('addOneOperation')"
      @confirmResult="(value)=>{confirmResult(value,'addOneOperation')}"
      width="1260"
    >
    </single-selector>
    <Modal v-model="modalValue.exeOperation" fullscreen :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('exeOperation')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>执行该操作组合</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <p><span>操作名称：</span><input type="text" v-model="currentExeOperation.name"></p>
          <p><span>操作介绍：</span><input type="text" v-model="currentExeOperation.description"></p>
          <p>全部操作内容：</p>
          <Table width="100%"  border :columns="exeOperationFormat" :data="exeOperationList" style="margin:0 auto;">
        </Table>
         <p style="text-align:center;margin:10px auto;"><Button type="warning" size="large" @click="openModal('addOneOperationInExe')">添加物品操作</Button></p>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="exeOperationSubmit('exeOperation')">提交</Button>
        <Button size="large" @click="closeModal('exeOperation')">取消</Button>
      </div>
    </Modal>
    <single-selector
      :askData="askData"
      :modalSwitch="modalValue.addOneOperationInExe"
      :columnsFormatData="columnsFormatSelect"
      @closeModal="closeModal('addOneOperationInExe')"
      @confirmResult="(value)=>{confirmResultExe(value,'addOneOperationInExe')}"
      width="1260"
    >
    </single-selector>
    <Modal v-model="modalValue.purchase" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('purchase')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>申购</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>物品名称：</td>
              <td>{{purchase.name}}</td>
            </tr>
            <tr>
              <td>类别：</td>
              <td>{{revealCatagory(purchase.catagory)}}</td>
            </tr>
            <tr>
              <td>属性：</td>
              <td>{{revealProperty(purchase.property)}}</td>
            </tr>
            <tr>
              <td>申购数量：</td>
              <td>
                <input type="number" placeholder v-model="purchase.amount" style="width:200px;" />
                {{purchase.pit}}
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="purchase.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="purchaseSubmit('purchase')">确定</Button>
        <Button size="large" @click="closeModal('purchase')">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modalValue.purchaseCart" :width="1280" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('purchaseCart')"></i>
      <p slot="header" class="sc-header">
        <span><Icon type="ios-cart" />  待购清单</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <div v-show="purchaseCart.length>0">
            <table class="purchase-form">
            <tr>
              <td style="width:3%;">序号</td>
              <td style="width:20%;">物品名称</td>
              <td style="width:10%;">类别</td>
              <td style="width:30%;">属性</td>
              <td style="width:12%;">申购数量</td>
              <td style="width:20%;">备注</td>
              <td style="width:5%;">操作</td>
            </tr>
            <tr v-for="(item,index) in purchaseCart" :key="item.id">
              <td>{{ index+1 }}</td>
              <td>{{item.name}}</td>
              <td>{{revealCatagory(item.catagory)}}</td>
              <td>{{revealProperty(item.property)}}</td>
              <td><input type="number" placeholder v-model="item.amount" class="pur-input" @change="localStore"/>
                {{item.pit}}</td>
              <td><textarea type="text" placeholder v-model="item.remark" class="pur-text" @change="localStore"/></td>
              <td>
                <span @click="delItemFromCart(index)" class="del-b">
                  <Icon type="ios-trash-outline" size="24"/>
                </span>
              </td>
            </tr>
          </table>
          <p class="rem-p">申购单备注：<input type="text" placeholder v-model="cartRemark" class="cart-text" /></p>
          
          </div>
          
          <p v-show="purchaseCart.length===0">申购单为空，请在物品列表内选择物品加入申购单。</p>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="purchaseCartSubmit('purchaseCart')" :disabled="purchaseCart.length===0">提交</Button>
        <Button size="large" @click="closeModal('purchaseCart')">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import goodsFlowList from "@/components/Common/GoodsFlowList.vue";
import goodsList from "@/components/Common/GoodsList.vue";
import purchaseList from "@/components/Common/PurchaseList.vue";
import simpleList from "@/components/Common/SimpleList.vue";
import singleSelector from "@/components/Common/SingleSelector.vue";
import wareNote from "@/components/Common/WareNote.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
import dayjs from 'dayjs'
//import goodsExpand from "./goodsExpand.vue";

function itemValue() {
  return {
    name: "",
    catagory: "",
    sub_catagory:"",
    property: {},
    alert_amount:0,
    pit: "",
    position_A: "",
    position_B: "",
    remark: ""
  };
}

function goodsAlter() {
  return {
    id: NaN,
    name: "",
    catagory: "",
    sub_catagory:"",
    property: {},
    alert_amount:0,
    pit: "",
    position_A: "",
    position_B: "",
    remark: ""
  };
}

function goodsFlow() {
  return {
    id: NaN,
    name: "",
    catagory: "",
    sub_catagory:"",
    property: {},
    pit: "",
    amount: 0,
    reason: "",
    place: "",
    remark: ""
  };
}

function propertyFac() {
  return {
    spec: "",
    model: "",
    mat: "",
    brand: "",
    seller: "",
    volume: null,
    diameter:null,
    bore:null,
    thickness:null,
    pressure:null,
    standard:"",
    grade:"",
    other: ""
  };
}

export default {
  name: "goods",
  props: [],
  components: {
    goodsFlowList,
    goodsList,
    simpleList,
    singleSelector,
    wareNote,
    purchaseList,
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "goodsList",
      tabSw:'goods',
      update_count: 0,
      update_count2:0,
      modalValue: {
        newCreate: false,
        goodsAlter: false,
        goodsIn: false,
        goodsOut: false,
        propertyBox: false,
        newOperation:false,
        addOneOperation:false,
        exeOperation:false,
        addOneOperationInExe:false,
        purchase:false,
        purchaseCart:false,
      },
      newItem: itemValue(),
      catagoryList: [],
      goods: goodsAlter(),
      goodsIn: goodsFlow(),
      inReasonList: [],
      goodsOut: goodsFlow(),
      outReasonList: [],
      property: propertyFac(),
      propertyForFormView:'',
      operation:{
        name:'',
        description:''
      },
      operationList:[
      ],
      currentExeOperation:{
        name:'',
        description:'',
        operationList:[]
      },
      exeOperationList:[],
      currentRecordDate:dayjs().format('YYYY-MM-DD'),
      currentRecordDateEnd:dayjs().format('YYYY-MM-DD'),
      spin:false,
      flowListOfDay:[],
      purchase:{},
      purchaseCart:[],
      cartRemark:"",
      columnsFormatData: [
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(goodsExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
        {
          title: "物品名称",
          key: "name",
          align: "center",
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.id.toString();
            return h(
              "span",
              {
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  },
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 110,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "数量",
          key: "amount",
          width: 80,
          align: "center",
          sortable:true
        },
        {
          title: "单位",
          key: "pit",
          width: 65,
          align: "center"
        },
        {
          title: "警戒库存",
          key: "alert_amount",
          width: 85,
          align: "center",
        },
        {
          title: "库位",
          key: "position_A",
          width: 85,
          align: "center"
        },
        {
          title: "货位",
          key: "position_B",
          width: 85,
          align: "center"
        },
        {
          title: "备注",
          key: "remark",
          width: 100,
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 240,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "green" },
                  on: {
                    click: () => {
                      this.modalValue.goodsIn = true;
                      this.goodsIn.id = params.row.id;
                      this.goodsIn.name = params.row.name;
                      this.goodsIn.catagory = params.row.catagory;
                      this.goodsIn.sub_catagory = params.row.sub_catagory;
                      this.goodsIn.property = params.row.property;
                      this.goodsIn.pit = params.row.pit;
                    }
                  }
                },
                "入库"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "green" },
                  on: {
                    click: () => {
                      this.modalValue.goodsOut = true;
                      this.goodsOut.id = params.row.id;
                      this.goodsOut.name = params.row.name;
                      this.goodsOut.catagory = params.row.catagory;
                      this.goodsOut.sub_catagory = params.row.sub_catagory;
                      this.goodsOut.property = params.row.property;
                      this.goodsOut.pit = params.row.pit;
                    }
                  }
                },
                "出库"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "green" },
                  on: {
                    click: () => {
                      this.modalValue.goodsAlter = true;
                      this.goods.id = params.row.id;
                      this.goods.name = params.row.name;
                      this.goods.catagory = params.row.catagory;
                      this.goods.sub_catagory = params.row.sub_catagory;
                      this.goods.property = JSON.parse(params.row.property);
                      this.goods.alert_amount = params.row.alert_amount;
                      this.goods.pit = params.row.pit;
                      this.goods.position_A = params.row.position_A;
                      this.goods.position_B = params.row.position_B;
                      this.goods.remark = params.row.remark;
                      this.property = this.goods.property;
                      this.propertyForFormView = this.revealProperty(params.row.property);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        },
        {
          title: "申购",
          align: "center",
          width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "blue" },
                  on: {
                    click: () => {
                      this.modalValue.purchase = true;
                      this.purchase.id = params.row.id;
                      this.purchase.name = params.row.name;
                      this.purchase.catagory = params.row.catagory;
                      this.purchase.sub_catagory = params.row.sub_catagory;
                      this.purchase.property = params.row.property;
                      this.purchase.pit = params.row.pit;
                      this.purchase.amount = 1;
                      this.purchase.remark = "";
                    }
                  }
                },
                "加入申购单"
              ),
            ]);
          }
        }
      ],
      columnsFormatFlow:[
        {
          title: "操作时间",
          key: "dotime",
          align: "center",
          width:100,
        },
        {
          title: "出库/入库",
          key: "direction",
          align: "center",
          width:100,
        },
        {
          title: "物品名称",
          key: "name",
          align: "center",
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.goods_id.toString();
            return h(
              "span",
              {
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                },
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 120,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "变动数量",
          key: "amount",
          align: "center",
          width:100,
        },
        {
          title: "来源/去向",
          key: "place",
          align: "center",
          width:100,
        },
        {
          title: "原因",
          key: "reason",
          align: "center",
          width:100,
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          width:100,
        },
        {
          title: "操作",
          align: "center",
          width: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmFlowDel(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
        
      ],
      columnsFormatOperation:[
        {
          title: "操作名称",
          key: "name",
          width: 200,
          align: "center",
        },
        {
          title: "操作介绍",
          key: "description",
          align: "center",
        },
        
        {
          title: "创建时间",
          key: "create_time",
          width: 180,
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "green" },
                  on: {
                    click: () => {
                      this.confirmOperationExe(params.row);
                    }
                  }
                },
                "执行"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmOperationDel(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      columnsFormatPurchase:[
        {
          title: "申购单号",
          key: "display_no",
          align: "center",
          width:150,
        },
        {
          title: "包含物品",
          key: "name",
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              p.row.itemlist.map(
                val=>{
                  return h(
                    "p",
                    {
                      props: {
                        title:this.revealProperty(val.property)
                      },
                      style: { textAlign: "left",margin:"5px 0" },
                    },
                    val.name+' × '+val.amount+val.pit
                  )
                }
              )
            );
          }
        },
        {
          title: "下单时间",
          key: "create_time",
          align: "center",
          width:200,
        },
        {
          title: "下单人",
          key: "create_account",
          align: "center",
          width:100,
        },
        {
          title: "申购备注",
          key: "remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "审核人",
          key: "verify_account",
          align: "center",
          width:100,
        },
        {
          title: "审核时间",
          key: "verify_time",
          align: "center",
          width:200,
        },
        {
          title: "审核结果",
          key: "verify_result",
          align: "center",
          width:100,
        },
        {
          title: "审核备注",
          key: "verify_remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          render: (h, params) => {
            return h("div", [
            h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "blue",marginRight:"5px" },
                  on: {
                    click: () => {
                      window.open("/item/packageDetail/" + params.row.enid,"_blank");
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmFlowDel(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
        
      ],
      addOperationFormat:[
        {
          title: "物品名称",
          key: "name",
          align: "center",
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.id.toString();
            return h(
              "span",
              {
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  },
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 110,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "单位",
          key: "pit",
          width: 65,
          align: "center"
        },
        {
          title: "库位",
          key: "position_A",
          width: 85,
          align: "center"
        },
        {
          title: "货位",
          key: "position_B",
          width: 85,
          align: "center"
        },
        {
          title: "方向",
          key: "direction",
          width: 85,
          align: "center",
          render: (h, p) => {
            return h(
              "select",
              {
                props:{
                  value:p.row.direction
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%'
                },
                on:{
                  change:(event)=>{
                    this.operationList[p.index].direction = event.target.value;
                    if(event.target.value==='出库'){
                      this.operationList[p.index].reason = '领用';
                    }else if(event.target.value==='入库'){
                      this.operationList[p.index].reason = '新购';
                    }
                  }
                },
              },
              [
                h('option',
                {
                  props:{
                    value:'出库'
                  }
                },
                '出库'

                ),
                h('option',
                {
                  props:{
                    value:'入库'
                  }
                },
                '入库'

                ),
              ]
            );
          }
        },
        {
          title: "变动数量",
          key: "amount",
          align: "center",
          width:100,
          render: (h, p) => {
            return h(
              "input",
              {
                domProps:{
                  value:p.row.amount,
                  type:'number'
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%',
                  textAlign:'center'
                },
                on:{
                  input:(event)=>{
                    if(/^(\d+)$/.test(event.target.value.toString())){
                      this.operationList[p.index].amount = event.target.value;
                    }else{
                      this.operationList[p.index].amount = 0;
                    }
                    
                  }
                },
              },
            );
          }
        },
        {
          title: "来源/去向",
          key: "place",
          align: "center",
          width:100,
          render: (h, p) => {
            return h(
              "input",
              {
                domProps:{
                  value:p.row.place
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%',
                  textAlign:'center'
                },
                on:{
                  input:(event)=>{
                    this.operationList[p.index].place = event.target.value;
                  }
                },
              },
            );
          }
        },
        {
          title: "原因",
          key: "reason",
          align: "center",
          width:100,
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          width:100,
          render: (h, p) => {
            return h(
              "input",
              {
                domProps:{
                  value:p.row.remark
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%',
                  textAlign:'center'
                },
                on:{
                  input:(event)=>{
                    this.operationList[p.index].remark = event.target.value;
                  }
                },
              },
            );
          }
        },
        {
          title: "操作",
          align: "center",
          width: 85,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.delThisOperation(params.row.index);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      columnsFormatSelect: [
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(goodsExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
        {
          title: "物品名称",
          key: "name",
          align: "center",
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.id.toString();
            return h(
              "span",
              {
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  },
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 110,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "数量",
          key: "amount",
          width: 80,
          align: "center",
          sortable:true
        },
        {
          title: "单位",
          key: "pit",
          width: 65,
          align: "center"
        },
        {
          title: "警戒库存",
          key: "alert_amount",
          width: 85,
          align: "center",
        },
        {
          title: "库位",
          key: "position_A",
          width: 85,
          align: "center"
        },
        {
          title: "货位",
          key: "position_B",
          width: 85,
          align: "center"
        },
        {
          title: "备注",
          key: "remark",
          width: 100,
          align: "center"
        },
      ],
      exeOperationFormat:[
        {
          title: "物品名称",
          key: "name",
          align: "center",
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.id.toString();
            return h(
              "span",
              {
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  },
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 110,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "单位",
          key: "pit",
          width: 65,
          align: "center"
        },
        {
          title: "库位",
          key: "position_A",
          width: 85,
          align: "center"
        },
        {
          title: "货位",
          key: "position_B",
          width: 85,
          align: "center"
        },
        {
          title: "方向",
          key: "direction",
          width: 85,
          align: "center",
          render: (h, p) => {
            return h(
              "select",
              {
                props:{
                  value:p.row.direction
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%'
                },
                on:{
                  change:(event)=>{
                    this.exeOperationList[p.index].direction = event.target.value;
                    if(event.target.value==='出库'){
                      this.exeOperationList[p.index].reason = '领用';
                    }else if(event.target.value==='入库'){
                      this.exeOperationList[p.index].reason = '新购';
                    }
                  }
                },
              },
              [
                h('option',
                {
                  props:{
                    value:'出库'
                  }
                },
                '出库'

                ),
                h('option',
                {
                  props:{
                    value:'入库'
                  }
                },
                '入库'

                ),
              ]
            );
          }
        },
        {
          title: "变动数量",
          key: "amount",
          align: "center",
          width:100,
          render: (h, p) => {
            return h(
              "input",
              {
                domProps:{
                  value:p.row.amount,
                  type:'number'
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%',
                  textAlign:'center'
                },
                on:{
                  input:(event)=>{
                    if(/^(\d+)$/.test(event.target.value.toString())){
                      this.exeOperationList[p.index].amount = event.target.value;
                    }else{
                      this.exeOperationList[p.index].amount = 0;
                    }
                    
                  }
                },
              },
            );
          }
        },
        {
          title: "来源/去向",
          key: "place",
          align: "center",
          width:100,
          render: (h, p) => {
            return h(
              "input",
              {
                domProps:{
                  value:p.row.place
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%',
                  textAlign:'center'
                },
                on:{
                  input:(event)=>{
                    this.exeOperationList[p.index].place = event.target.value;
                  }
                },
              },
            );
          }
        },
        {
          title: "原因",
          key: "reason",
          align: "center",
          width:100,
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          width:100,
          render: (h, p) => {
            return h(
              "input",
              {
                domProps:{
                  value:p.row.remark
                },
                style:{
                  border:'none',
                  outline:'none',
                  width:'100%',
                  textAlign:'center'
                },
                on:{
                  blur:(event)=>{
                    this.exeOperationList[p.index].remark = event.target.value;
                  }
                },
              },
            );
          }
        },
        {
          title: "操作",
          align: "center",
          width: 85,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.delExeOperation(params.row._index);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
    };
  },
  computed: {
    goodsCreateValid: function() {
      if (this.newItem.name !== "" && this.newItem.catagory !== "") {
        return false;
      } else {
        return true;
      }
    },
    operationValid:function(){
      if(this.operation.name.length>0){
        return false;
      }else{
        return true;
      }
    },
  },
  created() {
    this.getStaticOptionsData();
    if(localStorage.getItem("purchase")!==undefined&&Array.isArray(JSON.parse(localStorage.getItem("purchase")))){
      this.purchaseCart = JSON.parse(localStorage.getItem("purchase"));
    }
    
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "goodsOption"
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.catagoryList = response.data.res_record.catagoryList;
            this.inReasonList = response.data.res_record.inReasonList;
            this.outReasonList = response.data.res_record.outReasonList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content: "<p>" + "物品：" + value.name + "</p>",
        onOk: () => {
          this.recordFormatDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delGoods",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    confirmFlowDel(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content: "<p>" + "该操作记录：" + value.name +'|'+value.direction+'|'+value.amount+"</p>",
        onOk: () => {
          this.flowDel(value.id);
        },
        onCancel: () => {}
      });
    },
    flowDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delFlow",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    confirmOperationDel(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content: "<p>" + "该操作组合：" + value.name + "</p>",
        onOk: () => {
          this.recordOperationDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordOperationDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delOperation",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    confirmOperationExe(value) {
      this.currentExeOperation = JSON.parse(JSON.stringify(value));
      this.exeOperationList = JSON.parse(this.currentExeOperation.data);
      this.openModal('exeOperation');
    },
    exeOperationSubmit(label){
      this.currentExeOperation.operationList = this.exeOperationList;
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "exeOperation",
          exe: this.currentExeOperation,
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("执行成功！");
            this.update_count++;
            this.closeModal(label);
          } else {
            this.closeModal(label);
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value) {
      this.modalValue[value] = true;
    },
    closeModal(value) {
      this.modalValue[value] = false;
    },
    newCreateSubmit(value) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "createGoods",
          item: this.newItem
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("新建成功！");
            this.newItem = itemValue();
            this.property = propertyFac();
            this.closeModal(value);
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    newOperationSubmit(label){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "createOperation",
          operation: this.operation,
          operationList:this.operationList
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("新建成功！");
            this.closeModal(label);
            this.update_count2++;
          } else {
            this.closeModal(label);
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    goodsAlterSubmit(value) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "goodsAlter",
          item: this.goods
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("修改成功！");
            this.closeModal(value);
            this.goods = goodsAlter();
            this.property = propertyFac();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    goodsFlowSubmit(value) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: value,
          item: this[value]
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("修改成功！");
            this.closeModal(value);
            this[value] = goodsFlow();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    saveProperty(value) {
      if (this.modalValue.newCreate) {
        let tmp = JSON.stringify(this.property);
        this.newItem.property = JSON.parse(tmp);
        this.propertyForFormView = this.revealProperty(tmp);
      } else if (this.modalValue.goodsAlter) {
        let tmp = JSON.stringify(this.property);
        this.goods.property = JSON.parse(tmp);
        this.propertyForFormView = this.revealProperty(tmp);
      }
      this.closeModal(value);
    },
    revealProperty(value) {
      let tmp;
      if (typeof value === "string" && value.length > 0) {
        tmp = JSON.parse(value);
      } else {
        tmp = {};
      }
      let text = "";
      if (tmp.spec) {
        text += "规格:" + tmp.spec + ";";
      }
      if (tmp.model) {
        text += "型号:" + tmp.model + ";";
      }
      if (tmp.mat) {
        text += "材质:" + tmp.mat + ";";
      }
      if (tmp.volume) {
        text += "容积:" + tmp.volume + ";";
      }
      if (tmp.brand) {
        text += "品牌:" + tmp.brand + ";";
      }
      if (tmp.seller) {
        text += "供货商:" + tmp.seller + ";";
      }
      if (tmp.diameter) {
        text += "外径:" + tmp.diameter + ";";
      }
      if (tmp.bore) {
        text += "内径:" + tmp.bore + ";";
      }
      if (tmp.thickness) {
        text += "壁厚:" + tmp.thickness + ";";
      }
      if (tmp.pressure) {
        text += "压力:" + tmp.pressure + ";";
      }
      if (tmp.standard) {
        text += "标准:" + tmp.standard + ";";
      }
      if (tmp.grade) {
        text += "级别:" + tmp.grade + ";";
      }
      if (tmp.other) {
        text += "其他:" + tmp.other + ";";
      }
      return text;
    },
    revealCatagory(value) {
      let tmp = this.catagoryList.find(val => val.value === value);
      let text = "";
      if (tmp) {
        text = tmp.text;
      }
      return text;
    },
    confirmResult(value,label){
      let tmp = JSON.parse(JSON.stringify(value));
      tmp.amount = 1;
      tmp.direction = '出库';
      tmp.reason = '领用';
      tmp.place = '';
      tmp.remark = '';
      this.operationList.push(tmp);
      this.closeModal(label);
    },
    confirmResultExe(value,label){
      let tmp = JSON.parse(JSON.stringify(value));
      tmp.amount = 1;
      tmp.direction = '出库';
      tmp.reason = '领用';
      tmp.place = '';
      tmp.remark = '';
      this.exeOperationList.push(tmp);
      this.closeModal(label);
    },
    delThisOperation(index){
      this.operationList.splice(index,1);
      this.update_count2++;
    },
    delExeOperation(index){
      this.exeOperationList.splice(index,1);
    },
    tabClick(value){
      if(value==='record'){
        this.getFlowRecord();
      }
    },
    getFlowRecord(){
      this.spin = true;
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: 'flowRecord',
          theDay: this.currentRecordDate,
          theDayEnd:this.currentRecordDateEnd,
        })
        .then(response => {
          
          if (response.data.stat == "ok") {
            this.flowListOfDay = response.data.res_record;
            if(this.flowListOfDay.length===0){
              this.$Message.info('未发现出入库记录！');
            }
            
          } else {
            this.$Message.error(response.data.data.info);
          }
          this.spin = false;
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    purchaseSubmit(label){
      let tmp = this.purchaseCart.find(val=>val.id===this.purchase.id);
      if(tmp!==undefined){
        tmp.amount = parseInt(tmp.amount) + parseInt(this.purchase.amount);
        tmp.remark += this.purchase.remark;
      }else{
        this.purchaseCart.push(JSON.parse(JSON.stringify(this.purchase)));
      }
      this.localStore();
      this.closeModal(label);
    },
    delItemFromCart(index){
      this.purchaseCart.splice(index,1);
      this.localStore();
    },
    purchaseCartSubmit(label){
      this.$axios
        .post(this.$url + "/purchase", {
          userToken: userToken,
          askData: "newPurchaseCart",
          item: this.purchaseCart,
          remark:this.cartRemark,
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("提交成功！");
            this.purchaseCart = [];
            this.localStore();
            this.closeModal(label);
          } else {
            this.closeModal(label);
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    },
    localStore(){
      localStorage.setItem("purchase",JSON.stringify(this.purchaseCart));
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  width: 98%;
  min-width: 1280px;
  margin: 0 auto;
}
.title {
  text-align: center;
  margin: 10px auto;
  font-size: 20px;
}
.cr-form {
  width: 100%;
  border-collapse: collapse;
}

.cr-form td {
  height: 45px;
}

.cr-form td:first-child {
  width:20%;
  text-align: right;
}

.cr-form input,
.cr-form select {
  padding: 0 10px;
  outline: none;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #aaa;
}

textarea {
  padding: 5px;
}

.inner-content-wrapper>p{
  margin :16px 10px;
}

.inner-content-wrapper>p>input{
  border:none;
  outline:none;
  border-bottom: 1px solid #666;
  width:50%;
  text-align: center;
}

.record-wrapper{
  width:1200px;
  margin:0 auto;
  text-align: center;
}
.date-input{
  width:150px;
  padding: 5px 10px;
}

.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}



.print-button {
  width: fit-content;
  margin-bottom: 10px;
}

#to_print_task_tag {
  width:fit-content;
  margin: 0 auto;
}
.tag-wrapper {
  width: fit-content;
  margin: 0 auto;
  word-break: break-all;
  word-wrap: break-word;
  font-family: Arial, Helvetica, sans-serif;
  color:#333;
}

@media screen {
  .tag-wrapper {
    margin-bottom: 10px;
  }
}
.print-bt{
  float: right;
  margin-right:40px;
}

.purchase-form{
  width: 100%;
  border-collapse: collapse;
}

.purchase-form td{
  text-align: center;
  border:1px solid #999;
  padding: 3px 5px;
}

.pur-input{
  border:none;
  outline: none;
  text-align: center;
  border-bottom: 1px solid #999;
  width:60%;
}

.pur-text{
  border:none;
  outline: none;
  text-align: left;
  border-bottom: 1px solid #999;
}

.del-b{
  cursor: pointer;
}

.del-b:hover{
  color:red;
}

.rem-p{
  margin-top: 20px;
  text-align: right;
}
.cart-text{
  width:80%;
  padding: 3px 5px;
  border:none;
  outline: none;
  text-align: left;
  border-bottom: 1px solid #999;
}
</style>